export default "__VITE_ASSET__fCqJDXRQ__"